import { Component, HostListener, Inject, PLATFORM_ID, Renderer2, inject, } from '@angular/core';
import { HeaderComponent } from "../../header/header.component";
import { FooterComponent } from '../../footer/footer.component';
import { CommonModule } from '@angular/common';
import { WebService } from '../../services/web.service';
import { HttpClient, HttpClientModule, HttpHeaders } from '@angular/common/http';
import { MetaTagService } from '../../meta-tag.service';
import { environment, GINConstants } from '../../../environments/environments';
import { IconsFreeToolsComponent } from '../../icons-free-tools/icons-free-tools.component';
import { FeedbackComponent } from '../../feedback/feedback.component';
import { Meta, Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';
@Component({
  selector: 'app-cover-letter',
  standalone: true,
  imports: [HeaderComponent, CommonModule, HttpClientModule, FooterComponent, IconsFreeToolsComponent, FeedbackComponent],

  templateUrl: './cover-letter.component.html',
  styleUrl: './cover-letter.component.css'
})
export class CoverLetterComponent {
  private platformId = inject(PLATFORM_ID);

  shouldShowButton: boolean = false;
  activeTab: string = 'q1';
  word_count = 0;
  char_count = 0;
  editortext = '';
  ngOnInit(): void {
    this.metaService.updateTags("AI Cover Letter Generator - Create Job Winning Cover Letters", "AI cover letter generator helps you create personalized, ATS-friendly cover letters that highlight your skills and impress hiring managers instantly.", "https://www.grammarin.com/cover-letter", "https://www.grammarin.com/assets/images/OG-Images/cover-letter-generator.png", 'AI Cover Letter Generator');
    this.char_count = $("#form_detailed").text().length;
    this.word_count = $("#form_detailed").text().trim().split(/\s+/).filter(word => word.length > 0).length;
    this.activeTab = 'q1';
    this.loadTurnstileScript().then(() => this.renderTurnstile())



  }


  constructor(private _webservice: WebService, @Inject(PLATFORM_ID) private platformID: Object, private httpClient: HttpClient,
    private metaService: MetaTagService, private meta: Meta, private titleService: Title,) { }


  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (window.pageYOffset > 200) {
      this.shouldShowButton = true;
    } else {
      this.shouldShowButton = false;
    }
  }
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  public checkEmptyFields(form) {
    let emptyFields = [];

    if (form.form_name === '') {
      emptyFields.push('form_name');
    }
    if (form.form_title === '') {
      emptyFields.push('form_title');
    }
    if (form.form_detail.trim() === '') {
      emptyFields.push('form_detail');
    }
    return emptyFields;
  }
  public color: string = 'black';
  public esubText: string = '';
  public esubText2: string = '';
  eFsubText2: any;
  public loaderAlert: boolean = false;
  output: any;
  original: any;
  corrected: any;
  public eFsubIF: boolean = false;
  output_display = false;

  public form_name: any;
  public form_title: any;
  public form_detail: any;

  public eFormSubmission(event: any) {


    this.output_display = false;
    event.preventDefault();
    if (this.captchaToken) {


      this.got_recpatcha = false;
    } else {
      this.got_recpatcha = true;

      $('#dangerAlert').html('Captcha is not loaded. Please reload the page.');
      $('#dangerAlert').show();
      setTimeout(function () {
        $('#dangerAlert').hide();
      }, 3000);

      return
    }
    this.eFsubIF = false

    this.form_name = $('#form_name').val();
    this.form_title = $('#form_title').val();
    this.form_detail = $('#form_detail').val();
    let form = {
      form_name: this.form_name,
      form_title: this.form_title,
      form_detail: this.form_detail
    };
    let emptyFields = this.checkEmptyFields(form);
    if (emptyFields.length > 0) {
      this.color = '#721c24';
      this.eFsubText2 = 'Please provide the required fields';
      emptyFields.forEach(function (field) {
        $('#' + field).css("border-color", "red");
      });
      this.eFsubIF = true
      $("#eFsubText2").show();
      setTimeout(function () {
        $("#eFsubText2").hide();
        emptyFields.forEach(function (field) {
          $('#' + field).css("border-color", "#08BA9C");
        });
        this.eFsubIF = false
      }, 3000);
    }
    else {
      this.loaderAlert = true;
      const headers = new HttpHeaders({
        'Authorization': environment.AuthorizationGIN,
      });
      this.httpClient.post(environment.API_URL + '/api/coverLetter', { 'resume': this.form_name, 'tittle': this.form_title, 'description': this.form_detail }, { headers }).subscribe(
        (response) => {

          this.output_display = true;
          this.output = response['output']

          this.loaderAlert = false;
          $('#form_name').css("border-color", "#08BA9C").css("background-color", "white");;;
          $('#form_title').css("border-color", "#08BA9C").css("background-color", "white");;;
          $('#form_detail').css("border-color", "#08BA9C").css("background-color", "white");;;
        },
        (error) => {
          // console.error(error);
          this.output_display = true;
          this.loaderAlert = false;
          this.output = "Something went wrong. Please try again later."
          $('#form_name').val('').css("border-color", "#08BA9C");
          $('#form_title').val('').css("border-color", "#08BA9C");
          $('#form_detail').val('').css("border-color", "#08BA9C");
        }
      );

    }
  }

  public copiedtext: boolean = false;
  public copried_txt: string = '';


  copyToClipboard() {
    if (this.output) {

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = this.output;


      const selection = window.getSelection();
      const range = document.createRange();
      range.selectNodeContents(tempDiv);


      selection.removeAllRanges();
      selection.addRange(range);


      navigator.clipboard.write([
        new ClipboardItem({
          'text/html': new Blob([tempDiv.innerHTML], { type: 'text/html' }),
          'text/plain': new Blob([tempDiv.innerText], { type: 'text/plain' })
        })
      ]).then(() => {
        this.copiedtext = true;
        setTimeout(() => {
          this.copiedtext = false;
        }, 2000);
      }).catch(err => console.error('Failed to copy:', err));


      selection.removeAllRanges();
    }
  }

  reFreshWindow() {
    // window.location.reload();
    $('#form_title').val('').css("background-color", "rgba(247, 247, 250, 1)").css("border-color", "rgba(227, 227, 240, 1)");
    $('#form_detail').val('').css("background-color", "rgba(247, 247, 250, 1)").css("border-color", "rgba(227, 227, 240, 1)");
    $('#form_name').val('').css("background-color", "rgba(247, 247, 250, 1)").css("border-color", "rgba(227, 227, 240, 1)");
    this.output_display = false;
  }
  getContent(event: KeyboardEvent) {
    const target = document.getElementById("form_detailed") as HTMLTextAreaElement;
    if (!target) return;

    this.editortext = target.value.trim();
    this.char_count = this.editortext.length;
    this.word_count = this.editortext.split(/\s+/).filter(word => word !== "").length;

    const words_field = ["form_detailed"];

    if (this.word_count > 100) {
      this.color = "#721c24";
      this.eFsubText2 = "Please shorten your text";

      words_field.forEach((field) => {
        $("#" + field).css("border-color", "red");
      });

      this.eFsubIF = true;
      $("#eFsubText2").text(this.eFsubText2).show();

      setTimeout(() => {
        $("#eFsubText2").hide();
        words_field.forEach((field) => {
          $("#" + field).css("border-color", "");
        });
        this.eFsubIF = false;
      }, 3000);
    } else {
      $("#eFsubText2").hide();
      words_field.forEach((field) => {
        $("#" + field).css("border-color", "");
      });
      this.eFsubIF = false;
    }

  }

  steps = [
    {
      icon: 'clEnterJobDetails',
      title: 'Enter Job Details',
      description: 'Copy and paste the text or type directly into the box. You can also upload files from your device.',
    },
    {
      icon: 'clInitiateTheCheck',
      title: 'Initiate the Check',
      description: 'Hit the “Check Grammar” button to initiate the grammar check process.',
    },
    {
      icon: 'clCorrectTheMistakes',
      title: 'Correct the Mistakes',
      description: 'The mistakes existing in your text will be highlighted. Rectify them with the given suggestions.',
    },
    {
      icon: 'clDownloadResults',
      title: 'Download Results',
      description: 'Click the download button to save the updated file to your device.',
    },
  ];

  Formats = [
    {
      icon: 'clRemovesWriterBlock',
      title: 'Removes Writer’s Block ',
      description: 'Writer’s block can make it hard to start a cover letter. Our cover letter generator helps guide you step-by-step and create a well-written cover letter using the information you provide.',
    },
    {
      icon: 'clIncreasesChancesOfInterviews',
      title: 'Increases Chances of Interviews',
      description: 'The AI cover letter generator incorporates job-specific keywords and adheres to the standard formatting that recruiters expect. This increases the likelihood of catching a hiring manager’s attention and getting a call for an interview',
    },
    {
      icon: 'clHelpsEnglishSpeakers',
      title: 'Helps Non-Native English Speakers',
      description: 'This tool is an excellent help for non-native English speakers. It writes clear, correct, and professional cover letters, so you don’t have to worry about grammar mistakes or awkward wording. You can confidently apply for jobs and show your skills without language barriers holding you back.',
    },

  ];

  activeIndex = 0;

  setActive(index: number): void {
    this.activeIndex = index;
  }
  toggleTab(tabId: string): void {
    if (this.activeTab === tabId) {
      this.activeTab = '';
    } else {
      this.activeTab = tabId;
    }
  }
  selectedTab: string = 'tab1';
  selectTab(tab: string): void {

    this.selectedTab = tab;
  }
  selectTabImg(tab: string): void {

    this.selectedTab = tab;
  }
  getIcon(tab: string): string {
    return this.currentTab === tab
      ? '../../assets/images/punctuation/plus.svg'
      : '../../assets/images/punctuation/minus.svg';
  }
  currentTab: string = 'tab1';

  currenttoggleTab(tab: string): void {
    this.currentTab = this.currentTab === tab ? '' : tab;
  }
  recaptcha_message: string = "";


  loadTurnstileScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (typeof window['turnstile'] !== 'undefined') {
        resolve();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = () => reject('Failed to load Turnstile script');
      document.body.appendChild(script);
    });
  }

  renderTurnstile(): void {
    if (typeof window['turnstile'] !== 'undefined') {
      window['turnstile'].render('#recaptcha-container', {
        sitekey: environment.CaptchaKey,
        size: 'normal',
        callback: (token: string) => this.onTurnstileSuccess(token),
        'error-callback': () => this.onTurnstileError(),
      });

    } else {
      // console.error('Turnstile script not loaded.');
    }
  }

  got_recpatcha: boolean = false;
  captchaToken: string | null = null;
  captchaResponse: string;

  onTurnstileSuccess(token: string): void {
    // console.log('Turnstile token received:', token);
    this.captchaToken = token;
  }

  // Error callback when CAPTCHA fails
  onTurnstileError(): void {
    // console.error('Turnstile error occurred.');
    this.captchaToken = null;
  }
  onCaptchaResolved(captchaResponse: string) {
    this.captchaResponse = captchaResponse;
  }
  getIconSize(tab: string): { width: string, height: string } {
    const isPlus = this.currentTab === tab;
    return isPlus
      ? { width: '20px', height: '20px' }
      : { width: '20px', height: '8.69px' };
  }
}






